import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {webServiceConfig} from '../config/web-service.config';
import {map} from 'rxjs/operators';
import {DataTablesResponse} from '../models/dataTables-response';

@Injectable({
  providedIn: 'root'
})
export class CouponService {

  constructor(private http: HttpClient) { }

  getDatatable(dataTablesParameters): Observable<any> {
    return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}coupons/datatable`, dataTablesParameters, {})
      .pipe(map(response => {
        return response;
      }));
  }

  store(coupon: any): Observable<any> {
      return this.http.post(`${webServiceConfig.webServiceUrl}coupons/store`, coupon)
          .pipe(map(response => {
              return response;
          }));
  }

  update(coupon: any): Observable<any> {
    return this.http.put(`${webServiceConfig.webServiceUrl}coupons/${coupon.id}`, coupon)
        .pipe(map(response => {
            return response;
        }));
  }

  delete(id: number): Observable<any> {
      return this.http.delete(`${webServiceConfig.webServiceUrl}coupons/${id}`)
          .pipe(map(response => {
              return response;
          }));
  }

  getById(couponId: number): Observable<any> {
    return this.http.get(`${webServiceConfig.webServiceUrl}coupons/${couponId}`)
      .pipe(map(response => {
        return response;
      }));
  }

}
